import { render, staticRenderFns } from "./MyColorItems.vue?vue&type=template&id=7a90fe7a&scoped=true&"
import script from "./MyColorItems.vue?vue&type=script&lang=ts&"
export * from "./MyColorItems.vue?vue&type=script&lang=ts&"
import style0 from "./MyColorItems.vue?vue&type=style&index=0&id=7a90fe7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90fe7a",
  null
  
)

export default component.exports